import React from "react";
import ReactTooltip from "react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

interface Props {
  title: string;
  tooltip: string;
  tooltipId: string;
  children: React.ReactNode;
}

const CompanySettingsFieldSection = ({
  title,
  tooltip,
  tooltipId,
  children,
}: Props) => {
  return (
    <div>
      <h3 className="flex items-center gap-2 text-lg mb-2 font-medium text-gray-900">
        <span>{title}</span>
        <span data-tip data-for={tooltipId}>
          <InformationCircleIcon className="inline-flex w-6 text-gray-500" />
        </span>
        <ReactTooltip
          className="hover:visible:opacity-1 w-96"
          delayHide={300}
          effect="solid"
          html={false}
          place="right"
          id={tooltipId}
        >
          {tooltip}
        </ReactTooltip>
      </h3>
      {children}
    </div>
  );
};

export default CompanySettingsFieldSection;
